import styled, { createGlobalStyle } from "styled-components";

export const FontStyles = createGlobalStyle`
    * {
        font-family: 'Factor A', 'DM Sans', sans-serif;
        box-sizing: border-box;
        margin: 0;
    }

    #payment-select-page button:not(#payment-next-btn-app-wrapper *) {
        border-style: none;
    }

    #payment-back-btn {
        border-style: solid!important;
    }
`;

interface TextProps {
    fontSize: number,
    fontWeight?: number,
    align?: string,
    color?: string,
    lineHeight?: number
}

export const TextBold = styled.span<TextProps>`
    font-size: ${props => props.fontSize}px;
    font-weight: ${props => props.fontWeight ? props.fontWeight : props.theme.fontWeight.textBold};
    text-align: ${props => props.align};
    color: ${props => props.color ? props.theme.colors[props.color] : props.theme.colors.gray0};
    line-height: ${props => props.lineHeight ? `${props.lineHeight}px` : 'normal'};
`;

export const TextMedium = styled.span<TextProps>`
    font-size: ${props => props.fontSize}px;
    font-weight: ${props => props.fontWeight ? props.fontWeight : props.theme.fontWeight.textMedium};
    text-align: ${props => props.align};
    color: ${props => props.color ? props.theme.colors[props.color] : props.theme.colors.gray0};
    line-height: ${props => props.lineHeight ? `${props.lineHeight}px` : 'normal'};
`;

export const TextRegular = styled.span<TextProps>`
    font-size: ${props => props.fontSize}px;
    font-weight: ${props => props.fontWeight ? props.fontWeight : props.theme.fontWeight.textRegular};
    text-align: ${props => props.align};
    color: ${props => props.color ? props.theme.colors[props.color] : props.theme.colors.gray0};
    line-height: ${props => props.lineHeight ? `${props.lineHeight}px` : 'normal'};
`;

export const CenterButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 16px auto;
  max-width: 300px;
`;

export const Label = styled.label`
  display: none;
`;

export const DesktopOnly = styled.div`
    @media (max-width: 851px){
        display: none;
    }
`;

export const MobileOnly = styled.div`
    @media (min-width: 850px) {
        display: none;
    }
`;